module.exports = __webpack_public_path__ + "img/17_84.9c5a7f21.png";